import './polyfills';
import './configuration/lang/momentLocales';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router';
import { getUserSessionHooks } from './configuration';
import { ErrorBoundary } from './features/app/ErrorBoundary';
import { App } from './features/app/App';
import { createRoot } from 'react-dom/client';
import { ensureUserIsLoggedIn } from './configuration/login';
import { configureFullStore } from './configuration/setup/store';

const store = configureFullStore();

const renderApplication = () => {
    const container = document.getElementById('root');
    const root = createRoot(container!);

    root.render(
        <ErrorBoundary>
            <Provider store={store}>
                <HashRouter>
                    <App />
                </HashRouter>
            </Provider>
        </ErrorBoundary>,
    );
};

await ensureUserIsLoggedIn(renderApplication, getUserSessionHooks(store));
